import { ILocation } from '../../models';

export const areLocationsTheSame = (first: ILocation, second: ILocation) =>
	first.country === second.country &&
	first.city === second.city &&
	first.office === second.office;
